/* tslint:disable */
/* eslint-disable */
/**
 * Product App Microservice
 * Product App Tier
 *
 * The version of the OpenAPI document: 1.5.6-SNAPSHOT
 * Contact: akrivitzky@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BundleType = {
    Fixed: 'FIXED',
    Variable: 'VARIABLE'
} as const;
export type BundleType = typeof BundleType[keyof typeof BundleType];


export function instanceOfBundleType(value: any): boolean {
    for (const key in BundleType) {
        if (Object.prototype.hasOwnProperty.call(BundleType, key)) {
            if (BundleType[key as keyof typeof BundleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BundleTypeFromJSON(json: any): BundleType {
    return BundleTypeFromJSONTyped(json, false);
}

export function BundleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BundleType {
    return json as BundleType;
}

export function BundleTypeToJSON(value?: BundleType | null): any {
    return value as any;
}

export function BundleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BundleType {
    return value as BundleType;
}

